module.exports = __webpack_public_path__ + "img/consult_top_txt.9ad557b4.png";